// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3ROsg","label":"Completed_label__3USi4"};